module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-BlackItalic.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-BlackItalic.woff
 ** module id = 1094
 ** module chunks = 0
 **/